module.exports = __webpack_public_path__ + "img/3-img@2x.231e447c.jpg";